import ItemGrid from './Grid';
import ItemList from './List';



export default {
  Grid: ItemGrid,
  List: ItemList,
};
